import { Toaster } from '@/shared/ui/toaster.component';
import { RouterProvider, createRouter } from '@tanstack/react-router';
import React from 'react';
import { routeTree } from '../routeTree.gen';
import './config/aws.config';
import { AuthProvider, BrokerProvider, QueryProvider } from './context';

export const router = createRouter({ routeTree, defaultViewTransition: false });

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export function App() {
  return (
    <React.StrictMode>
      <QueryProvider>
        <AuthProvider>
          <BrokerProvider>
            <RouterProvider router={router} />
            <Toaster />
          </BrokerProvider>
        </AuthProvider>
      </QueryProvider>
    </React.StrictMode>
  );
}
